import {CMSLinkType} from "../Link";

export interface IUseCardLink {
  getURL(link:CMSLinkType): string;
}

const useCardLink = (): IUseCardLink => {

  const getURL = (link:CMSLinkType): string => {
    let url: string;
    if (link) {
      if ((link.type === 'reference') && (typeof link.reference?.value === 'object') && link.reference?.value.slug) {
        // link with slug
        url = (link.type === 'reference') && (typeof link.reference?.value === 'object') && link.reference?.value.slug
          ? `${link.reference?.relationTo !== 'pages' ? `/${link.reference?.relationTo}/${link.reference?.value.slug}` : ''}/${
            link.reference.value.industries.title.toLowerCase()}/${link.reference.value.categories.title.toLowerCase()}/${link.reference.value.slug}`
          : link.url
      } else {
        // link with id
        url = (link.type === 'reference') && (typeof link.reference?.value === 'object') && link.reference?.value.id
          ? `${link.reference?.relationTo !== 'pages' ? `/${link.reference?.relationTo}/${link.reference?.value.id}` : ''}/${
            link.reference.value.industries.title.toLowerCase()}/${link.reference.value.categories.title.toLowerCase()}/${link.reference.value.id}`
          : link.url
      }
    }

    if (!url) {
      url = ''
    }

    url = url.replace('/global', '')
    return url;
  }

  return {
    getURL
  }
};

export default useCardLink;
